// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__nTwlG","faq1":"faq_faq1__zq6RR"};